export default {
    values: {
        'NPS Survey': 'Pesquisa NPS',
        'NPS Answers': 'Respostas de NPS',
        'Responses collected from the popup': 'Respostas coletadas pelo popup',
        'Could not load NPS answers': 'Não foi possível carregar as respostas de NPS',
        'Could not load platform users': 'Não foi possível carregar os usuários da plataforma',
        'Are you sure you want to delete?': 'Tem certeza de que deseja excluir?',
        'NPS answer deleted successfully': 'Resposta de NPS excluída com sucesso',
        'Error deleting NPS answer': 'Erro ao excluir resposta de NPS',
        'Please select a user': 'Selecione um usuário',
        'This user is already registered': 'Este usuário já está cadastrado',
        'User registered successfully': 'Usuário cadastrado com sucesso',
        'Could not register user': 'Não foi possível cadastrar o usuário',
        'Add User': 'Adicionar usuário',
        'Add User to NPS survey': 'Adicionar usuário à pesquisa de NPS',
        'User': 'Usuário',
        'Select user': 'Selecione o usuário',
        'All available users are already registered': 'Todos os usuários disponíveis já estão cadastrados',
        'Score': 'Nota',
        'Comment': 'Comentário',
        'Answered': 'Respondeu',
        'Answered At': 'Respondido em',
        'Retries': 'Tentativas',
        'Last Retry': 'Última tentativa',
        'Actions': 'Ações',
        'No NPS answers yet': 'Ainda não há respostas de NPS',
        'Responses submitted in the popup will appear here.': 'As respostas enviadas pelo popup aparecerão aqui.',
        'Yes': 'Sim',
        'No': 'Não',
        'Delete': 'Excluir',
        'Thanks for answering the NPS survey': 'Obrigado por responder à pesquisa de NPS',
        'Could not submit your NPS answer': 'Não foi possível enviar sua resposta de NPS',
        'Could not update retry information': 'Não foi possível atualizar as informações de tentativa',
        'Close': 'Fechar',
        'How likely are you to recommend this platform to a colleague?': 'Qual a probabilidade de você recomendar esta plataforma para um colega?',
        'Choose a score from 0 to 10': 'Escolha uma nota de 0 a 10.',
        'Not likely': 'Pouco provável',
        'Very likely': 'Muito provável',
        'Comment (optional)': 'Comentário (opcional)',
        'Tell us what influenced your score': 'Conte o que influenciou sua nota',
        'Submitting...': 'Enviando...',
        'Send feedback': 'Enviar feedback'
    }
}
